module.exports = __webpack_public_path__ + "img/la_voix_du_nord.3ba8ecf.png";